import s from './SafetyHeaderFields.module.scss';

interface SafetyHeaderFieldsProps {
  shipName: string;
  registrationNumber: string;
  onImoNumber: string;
}

export function SafetyHeaderFields({
  shipName,
  registrationNumber,
  onImoNumber,
}: SafetyHeaderFieldsProps) {
  return (
    <div className={s.root}>
      <HeaderCell label="Ship Name" value={shipName} />
      <HeaderCell label="Registration Number/ID" value={registrationNumber} />
      <HeaderCell label="ON/IMO Number" value={onImoNumber} />
    </div>
  );
}

function HeaderCell({ label, value }: { label: string; value: string }) {
  return (
    <div className={s.cell}>
      <span className={s.label}>{label}</span>
      <span className={s.value}>{value || '-'}</span>
    </div>
  );
}
